import React, { useState } from 'react';
import { Toggle } from '@core/uilibrary';
import TextFieldInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/text-field-op/ts/textFieldInline';
import TextAreaInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/textarea-field-op/ts/textAreaInline';

export const DraftTextField: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextFieldInline
      value={draft}
      placeholder={placeholder}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

export const DraftTextArea: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  rows?:         number;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, rows, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextAreaInline
      value={draft}
      placeholder={placeholder}
      rows={rows}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

export const LabelRow: React.FC<{
  label:     string;
  required?: boolean;
  bold?:     boolean;
  toggle?:   { checked: boolean; onChange: (v: boolean) => void };
}> = ({ label, required, bold, toggle }) => (
  <div className="scl--cms-content-edit-business-label-row">
    <span className={`scl--cms-content-edit-business-label${bold ? ' scl--cms-content-edit-business-label--bold' : ''}`}>
      {label}{required && <span className="scl--cms-content-edit-business-required"> *</span>}
    </span>
    {toggle && <Toggle checked={toggle.checked} onChange={toggle.onChange} />}
  </div>
);

export const SplitRow: React.FC<{
  currentText: string;
  multiline?:  boolean;
  children:    React.ReactNode;
}> = ({ currentText, multiline, children }) => (
  <div className={`scl--cms-content-edit-business-split-row${multiline ? ' scl--cms-content-edit-business-split-row--multiline' : ''}`}>
    <div className="scl--cms-content-edit-business-split-accent" />
    <div className="scl--cms-content-edit-business-split-body">
      <span className="scl--cms-content-edit-business-split-current">{currentText}</span>
      <div className={`scl--cms-content-edit-business-split-slot${multiline ? ' scl--cms-content-edit-business-split-slot--textarea' : ''}`}>
        {children}
      </div>
    </div>
  </div>
);